/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unlisted_Youtube_Vimeo_Or_GoInputs */

const en_unlisted_youtube_vimeo_or_go = /** @type {(inputs: Unlisted_Youtube_Vimeo_Or_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlisted YouTube, Vimeo, or Google Drive link`)
};

const es_unlisted_youtube_vimeo_or_go = /** @type {(inputs: Unlisted_Youtube_Vimeo_Or_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlace oculto de YouTube, Vimeo o Google Drive`)
};

const fr_unlisted_youtube_vimeo_or_go = /** @type {(inputs: Unlisted_Youtube_Vimeo_Or_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien non répertorié YouTube, Vimeo, ou Google Drive`)
};

const de_unlisted_youtube_vimeo_or_go = /** @type {(inputs: Unlisted_Youtube_Vimeo_Or_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht gelisteter YouTube-, Vimeo- oder Google Drive-Link`)
};

const ja_unlisted_youtube_vimeo_or_go = /** @type {(inputs: Unlisted_Youtube_Vimeo_Or_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`限定公開のYouTube、Vimeo、またはGoogle Driveのリンク`)
};

const zh_unlisted_youtube_vimeo_or_go = /** @type {(inputs: Unlisted_Youtube_Vimeo_Or_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不公开的 YouTube、Vimeo 或 Google Drive 链接`)
};

const ar_unlisted_youtube_vimeo_or_go = /** @type {(inputs: Unlisted_Youtube_Vimeo_Or_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رابط يوتيوب غير مدرج أو فيميو أو جوجل درايف`)
};

const id_unlisted_youtube_vimeo_or_go = /** @type {(inputs: Unlisted_Youtube_Vimeo_Or_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautan YouTube Unlisted, Vimeo, atau Google Drive`)
};

const it_unlisted_youtube_vimeo_or_go = /** @type {(inputs: Unlisted_Youtube_Vimeo_Or_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link privato YouTube, Vimeo, o Google Drive`)
};

const ru_unlisted_youtube_vimeo_or_go = /** @type {(inputs: Unlisted_Youtube_Vimeo_Or_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ссылка по доступу на YouTube, Vimeo или Google Диск`)
};

const pt_unlisted_youtube_vimeo_or_go = /** @type {(inputs: Unlisted_Youtube_Vimeo_Or_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link não listado do YouTube, Vimeo ou Google Drive`)
};

const ko_unlisted_youtube_vimeo_or_go = /** @type {(inputs: Unlisted_Youtube_Vimeo_Or_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일부 공개된 YouTube, Vimeo 또는 Google 드라이브 링크`)
};

/**
* | output |
* | --- |
* | "Unlisted YouTube, Vimeo, or Google Drive link" |
*
* @param {Unlisted_Youtube_Vimeo_Or_GoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const unlisted_youtube_vimeo_or_go = /** @type {((inputs?: Unlisted_Youtube_Vimeo_Or_GoInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unlisted_Youtube_Vimeo_Or_GoInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unlisted_youtube_vimeo_or_go(inputs)
	if (locale === "es") return es_unlisted_youtube_vimeo_or_go(inputs)
	if (locale === "fr") return fr_unlisted_youtube_vimeo_or_go(inputs)
	if (locale === "de") return de_unlisted_youtube_vimeo_or_go(inputs)
	if (locale === "ja") return ja_unlisted_youtube_vimeo_or_go(inputs)
	if (locale === "zh") return zh_unlisted_youtube_vimeo_or_go(inputs)
	if (locale === "ar") return ar_unlisted_youtube_vimeo_or_go(inputs)
	if (locale === "id") return id_unlisted_youtube_vimeo_or_go(inputs)
	if (locale === "it") return it_unlisted_youtube_vimeo_or_go(inputs)
	if (locale === "ru") return ru_unlisted_youtube_vimeo_or_go(inputs)
	if (locale === "pt") return pt_unlisted_youtube_vimeo_or_go(inputs)
	return ko_unlisted_youtube_vimeo_or_go(inputs)
});